import { render, staticRenderFns } from "./EditBalance.vue?vue&type=template&id=4c4a9d49&"
import script from "./EditBalance.vue?vue&type=script&lang=js&"
export * from "./EditBalance.vue?vue&type=script&lang=js&"
import style0 from "./EditBalance.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports